/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetExploreNewUniverse
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetExploreNewUniverseQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetExploreNewUniverseQuery>({ ...options, query: Operations.GetExploreNewUniverseDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetExploreNewUniverse = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetExploreNewUniverseQuery, TypescriptOperationsGenerated.GetExploreNewUniverseQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetExploreNewUniverseDocument, options);
};
export type PageGetExploreNewUniverseComp = React.FC<{data?: TypescriptOperationsGenerated.GetExploreNewUniverseQuery, error?: Apollo.ApolloError}>;
export const withPageGetExploreNewUniverse = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetExploreNewUniverseQuery, TypescriptOperationsGenerated.GetExploreNewUniverseQueryVariables>) => (WrappedComponent:PageGetExploreNewUniverseComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetExploreNewUniverseDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetExploreNewUniverse = {
      getServerPage: getServerPageGetExploreNewUniverse,
      withPage: withPageGetExploreNewUniverse,
      usePage: useGetExploreNewUniverse,
    }